import { __rest } from '../../_virtual/_tslib.js';
import { HeadlinePresentation } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated (date: 17.11.2021) */

var Sizes;

(function (Sizes) {
  Sizes["H1"] = "h1";
  Sizes["H2"] = "h2";
  Sizes["H3"] = "h3";
  Sizes["H4"] = "h4";
  Sizes["H5"] = "h5";
  Sizes["H6"] = "h6";
})(Sizes || (Sizes = {}));
/** @deprecated */


var Variants;

(function (Variants) {
  Variants["STRONG"] = "strong";
  Variants["THIN"] = "thin";
})(Variants || (Variants = {}));
/** @deprecated */


var Colors;

(function (Colors) {
  Colors[Colors["DEFAULT"] = 0] = "DEFAULT";
  Colors[Colors["ACCENT"] = 1] = "ACCENT";
})(Colors || (Colors = {}));

var defaultProps = {
  color: Colors.DEFAULT,
  size: "h1",
  variant: "strong",
  overlineAs: "div",
  sublineAs: "div"
};

var Headline = function Headline(props) {
  var children = props.children,
      asSpan = props.asSpan,
      variant = props.variant,
      restProps = __rest(props, ["children", "asSpan", "variant"]);

  var component = asSpan ? "span" : props.as;
  return /*#__PURE__*/createElement(HeadlinePresentation, Object.assign({
    as: component
  }, restProps, {
    variant: variant === "strong" ? "" : "thin"
  }), children);
};

Headline.defaultProps = defaultProps;
Headline.Sizes = Sizes;
Headline.Variants = Variants;
Headline.Colors = Colors; // zu den ts-ignores: Sizes/Variants/Colors müssten auch omittet werden mit einem solchen Konstrukt:
// Omit<IHeadline<Omit<IHeadlineProps, "size">>, "Sizes" | "Variants" | "Colors">
// das versteht Typescript aber an der Stelle, wo H1 verwendet wird, nicht.
// @ts-ignore

var H1 = function H1(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h1"
  }, props));
}; // @ts-ignore


var H1Thin = function H1Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h1",
    variant: "thin"
  }, props));
}; // @ts-ignore


var H2 = function H2(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h2"
  }, props));
}; // @ts-ignore


var H2Thin = function H2Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h2",
    variant: "thin"
  }, props));
}; // @ts-ignore


var H3 = function H3(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h3"
  }, props));
}; // @ts-ignore


var H3Thin = function H3Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h3",
    variant: "thin"
  }, props));
}; // @ts-ignore


var H4 = function H4(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h4"
  }, props));
}; // @ts-ignore


var H4Thin = function H4Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h4",
    variant: "thin"
  }, props));
}; // @ts-ignore


var H5 = function H5(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h5"
  }, props));
}; // @ts-ignore


var H5Thin = function H5Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h5",
    variant: "thin"
  }, props));
}; // @ts-ignore


var H6 = function H6(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h6"
  }, props));
}; // @ts-ignore


var H6Thin = function H6Thin(props) {
  return /*#__PURE__*/createElement(Headline, Object.assign({
    size: "h6",
    variant: "thin"
  }, props));
};

Headline.displayName = "Headline";
H1.displayName = "H1";
H1Thin.displayName = "H1Thin";
H2.displayName = "H2";
H2Thin.displayName = "H2Thin";
H3.displayName = "H3";
H3Thin.displayName = "H3Thin";
H4.displayName = "H4";
H4Thin.displayName = "H4Thin";
H5.displayName = "H5";
H5Thin.displayName = "H5Thin";
H6.displayName = "H6";
H6Thin.displayName = "H6Thin";

export { Colors, H1, H1Thin, H2, H2Thin, H3, H3Thin, H4, H4Thin, H5, H5Thin, H6, H6Thin, Headline, Sizes, Variants };
